import apiClient from '../utilities/apiClient.utility';

const programUrl = `${window.config.CONNECT_URLS.products}`;

export const getDosesList = async ({program_id,patient_id}) =>{
    return await apiClient.get(`${programUrl}/${program_id}/dashboard/${patient_id}/doses`
)
}

export const createDoses = async ({program_id,patient_id,payload}) =>{
    return await apiClient.post(`${programUrl}/${program_id}/dashboard/${patient_id}/doses`,payload
)
}  
export const updateDoses = async ({program_id,patient_id,payload}) =>{
    return await apiClient.put(`${programUrl}/${program_id}/dashboard/${patient_id}/doses`,payload
) 
}